<template>
  <div class="map-layer-controls">
    <MapOverlays :map="map" :autoShowSpecies="autoShowSpecies" :layerCeiling="layerCeiling" ref="mapOverlays" @state="overlayState = $event" @toggle-species="toggleSpeciesLayer"/>
    <v-row class="map-button-row-top" dense justify="end">
      <div class="map-overlay-toggle-group" @mouseenter="hideMapTips">
        <Icon
        v-if="overlayState.species.canShow"
        icon="mdi-paw"
        @icon-clicked="toggleSpeciesLayer"
        :disabled="otherOverlayActive('species')"
        :tooltipText="$t('speciesLayer')"
        xLarge
        :small="false"
        :iconColor="overlayState.species.active ? 'primary' : 'grey darken-2'"
        margin="map-option-button"
        tooltipColor="black"
        elementId="map-species-layer-toggle"/>
        <Icon
        v-if="companyInfo.hasCustomMapLayers"
        icon="mdi-layers-outline"
        @icon-clicked="toggleCustomLayers"
        :disabled="otherOverlayActive('custom')"
        :tooltipText="$t('customLayers')"
        xLarge
        :small="false"
        :iconColor="overlayState.custom.active || overlayState.custom.open ? 'primary' : 'grey darken-2'"
        margin="map-option-button"
        tooltipColor="black"
        elementId="map-custom-layers-toggle"/>
        <Icon
        icon="mdi-image-filter-hdr"
        @icon-clicked="toggleTopo"
        :disabled="otherOverlayActive('topo')"
        :tooltipText="$t('topoLayer')"
        xLarge
        :small="false"
        :iconColor="overlayState.topo.active ? 'primary' : 'grey darken-2'"
        margin="map-option-button"
        tooltipColor="black"
        elementId="map-topo-toggle"/>
        <Icon
        icon="mdi-tractor"
        @icon-clicked="analyzeSoil"
        :disabled="otherOverlayActive('soil')"
        :tooltipText="$t('analyzeOperability')"
        xLarge
        :small="false"
        :iconColor="overlayState.soil.active ? 'primary' : 'grey darken-2'"
        margin="map-option-button"
        tooltipColor="black"
        elementId="map-soil-toggle"/>
        <Icon
        icon="mdi-crosshairs-gps"
        @icon-clicked="toggleNearbyTracts"
        :tooltipText="$t('toggleNearbyTracts', { toggle: $t(overlayState.nearbyTracts.active ? 'hide' : 'show') })"
        xLarge
        :small="false"
        :iconColor="overlayState.nearbyTracts.active ? 'primary' : 'grey darken-2'"
        margin="map-option-button"
        tooltipColor="black"
        elementId="map-nearby-tracts-toggle"/>
        <Icon
        v-if="overlayState.nearbyTracts.active"
        icon="mdi-vector-polygon"
        @icon-clicked="toggleNearbyBoundaries"
        :disabled="otherOverlayActive('nearbyBoundaries')"
        :tooltipText="$t('nearbyBoundaries')"
        xLarge
        :small="false"
        :iconColor="overlayState.nearbyBoundaries.active ? 'primary' : 'grey darken-2'"
        margin="map-option-button"
        tooltipColor="black"
        elementId="map-nearby-boundaries-toggle"/>
      </div>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { overlaysStack } from '@/utils/map/overlayLayers'

export default {
  name: 'MapLayerControls',

  components: {
    Icon: () => import('@/components/helper/Icon.vue'),
    MapOverlays: () => import('@/components/maps/MapOverlays.vue')
  },

  props: {
    map: {
      type: Object,
      default: null
    },
    tract: {
      type: Object,
      required: true
    },
    autoShowSpecies: {
      type: Boolean,
      default: true
    },
    layerCeiling: {
      type: String,
      default: 'labels'
    }
  },

  data: () => ({
    overlayState: { species: { canShow: false, active: false }, topo: { active: false }, soil: { active: false }, custom: { active: false, open: false }, nearbyTracts: { active: false }, nearbyBoundaries: { active: false } }
  }),

  computed: {
    ...mapGetters('user', ['companyInfo'])
  },

  methods: {
    toggleSpeciesLayer () {
      if (this.otherOverlayActive('species')) {
        this.setSnack(this.$t('disableOtherLayersToToggle', { layer: this.$t('speciesLayer') }))
        return
      }
      if (this.$refs.mapOverlays) this.$refs.mapOverlays.toggleSpeciesLayer()
    },

    toggleTopo () {
      if (this.$refs.mapOverlays) this.$refs.mapOverlays.toggleTopo()
    },

    toggleCustomLayers () {
      if (this.$refs.mapOverlays) this.$refs.mapOverlays.toggleCustomLayersPanel()
    },

    analyzeSoil () {
      if (this.$refs.mapOverlays) this.$refs.mapOverlays.analyzeSoilOperability()
    },

    toggleNearbyTracts () {
      if (this.$refs.mapOverlays) this.$refs.mapOverlays.toggleNearbyTracts({ tractId: this.tract.tractId })
    },

    toggleNearbyBoundaries () {
      if (this.$refs.mapOverlays) this.$refs.mapOverlays.toggleNearbyTractBoundaries({ tractId: this.tract.tractId, spot: this.tract.spot })
    },

    hideMapTips () {
      if (this.$refs.mapOverlays) this.$refs.mapOverlays.hideDataTips()
    },

    otherOverlayActive (name) {
      return ['species', 'topo', 'soil', 'custom', 'nearbyBoundaries'].some(o => o !== name && !overlaysStack(name, o) && this.overlayState[o]?.active)
    }
  }
}
</script>
